module.exports = __webpack_public_path__ + "static/media/montserrat-latin-900-normal.308a7ca8.woff";